import http from "../http-common";

class TenantService {
  register(data) {
    return http.post("/tenants/register", data);
  }

  getAll(params = {}) {
    return http.get("/tenants", { params });
  }

  get(id) {
    return http.get(`/tenants/${id}`);
  }

  create(data) {
    return http.post("/tenants", data);
  }

  update(id, data) {
    return http.put(`/tenants/${id}`, data);
  }

  delete(id) {
    return http.delete(`/tenants/${id}`);
  }

  getRoles(tenantId) {
    return http.get(`/tenants/${tenantId}/roles`);
  }

  syncRoles(tenantId, roleIds) {
    return http.put(`/tenants/${tenantId}/roles`, { role_ids: roleIds });
  }
}

export default new TenantService();
